import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-record-right-sidebar',
  templateUrl: './record-right-sidebar.component.html',
  styleUrls: ['./record-right-sidebar.component.scss']
})
export class RecordRightSidebarComponent implements OnInit{
  @Input() relatedTypeId!: number;
  @Input() recordId!: number;
  @Input() relatedConditions: { relatedTypeId: number; recordId: number }[] = [];

  public activeTab: string = 'Timeline';

  ngOnInit(): void {
    const storedTab = localStorage.getItem('rsbActTab');
    if (storedTab === 'Activites') {
      this.activeTab = 'Activities';
      localStorage.setItem('rsbActTab', this.activeTab);
      return;
    }
    this.activeTab = storedTab ? storedTab : 'Timeline';
  }

  public onTabSelect(e){
    this.activeTab = e.heading;
    localStorage.setItem('rsbActTab', this.activeTab);
  }

}
